<template>
<div style="margin:5px;">
     <Row>
        <Col span="24">
            <Breadcrumb :style="{margin: '20px 0'}">
              <BreadcrumbItem>系统设置</BreadcrumbItem>
              <BreadcrumbItem>用户管理</BreadcrumbItem>
            </Breadcrumb>
        </Col>
     </Row>
      <Row>
          
            <Form ref="queryFormRef" :model="queryForm" :label-width="60" inline>
              <Col span="21" offset="3" >
                    <FormItem label="用户名" prop="userId">
                      <Input v-model="queryForm.userId" placeholder="请输入用户名称"></Input>
                    </FormItem>
                    <FormItem label="地市" prop="city" v-show="showcity">
                        <Select  v-model="queryForm.city" @on-clear="clearCity"  @on-change="getDist" style="width:100px" 
                        :transfer="true" :clearable="true">
                            <Option v-for="item in queryForm.cityList" :value="item.groupid" :key="item.groupid">{{ item.groupname }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem  label="区县" prop="dist" :label-width="40" v-show="showcountry">
                            <Select  v-model="queryForm.dist" @on-clear="clearDist" :clearable="true" :transfer="true" style="width:100px">
                                <Option v-for="item in queryForm.distList" :value="item.groupid" :key="item.groupid">
                                {{ item.groupname }}</Option>
                            </Select>
                    </FormItem>
                 <Button type="info"  @click="queryUser" ghost>查询</Button>
                <Button type="success" ghost @click="resetQueryForm">重置</Button>
              </Col>
            </form>
      </Row>
      <br>
      
      <hr style="margin:5px 0;height:3px;">
      <Row >
          <Col span="10" offset="1">
            <div>
              <Button type="info"  @click="openAddForm" >新增</Button>
            </div>
          </Col>
      </Row>
      <br>
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
                <template slot-scope="{ row }" slot="name">
                  <strong>{{ row.name }}</strong>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                  <Button  v-if="row.userState == 0" type="primary" size="small" style="margin-right: 5px" @click="stop(row)" >启用</Button>
                  <Button  v-else type="primary" size="small" style="margin-right: 5px" @click="stop(row)" >停用
                    </Button>
                  <Button type="info" size="small" @click="openUpdateForm(row)">修改</Button>
                  <Button type="error" size="small" @click="deleleRows(row)">删除</Button>
                </template>
              </Table>
          </Col>
      </Row>
      <Row>
        <Col span="24">
          <div>
            <Footer>
              <Page show-sizer show-total :total="rowCount" :current="current"
                :page-size="pageSize"  @on-change="changePage"
                @on-page-size-change="changeSize" />
            </Footer>
          </div>
        </Col>
    </Row>
  <UserFormAddProvince ref="userFormAddProvince"></UserFormAddProvince>
  <UserFormAddCity ref="userFormAddCity"></UserFormAddCity>
  <UserFormAddDist ref="userFormAddDist"></UserFormAddDist>
  <UserFormUpdateProvince ref="userFormUpdateProvince"></UserFormUpdateProvince>
  <UserFormUpdateCity ref="userFormUpdateCity"></UserFormUpdateCity>
  <UserFormUpdateDist ref="userFormUpdateDist"></UserFormUpdateDist>
</div>
</template>

<script>
  import Bus from '@/utils/bus.js'
  import UserFormAddProvince from '@/pages/platform/sys/user/UserFormAddProvince';
  import UserFormAddCity from '@/pages/platform/sys/user/UserFormAddCity';
  import UserFormAddDist from '@/pages/platform/sys/user/UserFormAddDist';
  import UserFormUpdateProvince from '@/pages/platform/sys/user/UserFormUpdateProvince';
  import UserFormUpdateCity from '@/pages/platform/sys/user/UserFormUpdateCity';
  import UserFormUpdateDist from '@/pages/platform/sys/user/UserFormUpdateDist';

  export default {
    components: {
      UserFormAddProvince,
      UserFormAddCity,
      UserFormAddDist,
      UserFormUpdateProvince,
      UserFormUpdateCity,
      UserFormUpdateDist,
    },
    methods: {
      queryUser(){
        this.current = 1
        this.loadPage()
      },
      selectRow(selection) {
        this.selectRows = selection;
      },
      //打开新增对话框
      openAddForm() {
        let curRegion = this.$store.getters.getCurAreaCode().regionCode
        //省级
        if (curRegion.length == 2) {
          this.$refs.userFormAddProvince.openModal();
        } else if(curRegion.length == 4){
           this.$refs.userFormAddCity.openModal();
        } else if(curRegion.length == 6){
           this.$refs.userFormAddDist.openModal();
        }
        
      },
      //打开修改对话框
      openUpdateForm(row) {
         let curRegion = this.$store.getters.getCurAreaCode().regionCode
        //省级
        if (curRegion.length == 2) {
          this.$refs.userFormUpdateProvince.openModal(row);
        } else if(curRegion.length == 4){
           this.$refs.userFormUpdateCity.openModal(row);
        } else if(curRegion.length == 6){
           this.$refs.userFormUpdateDist.openModal(row);
        }
      },
 
    
      //询问是否删除
      deleleRows(row) {
        this.deleteId = row.id
        this.$Modal.confirm({
          title: '提示信息',
          content: `确认要删除\"${row.userId}\"吗?`,
          onOk: this.doDelete
        })
      },
      
      loadPage() {
        //设置区域查询条件
        if (this.queryForm.dist != '' && this.queryForm.dist != undefined ) {
              this.queryForm.regionCode = this.queryForm.dist 
        } else if(this.queryForm.city != '' && this.queryForm.city != undefined ){
            this.queryForm.regionCode = this.queryForm.city 
        }else{
          this.queryForm.regionCode = this.$store.getters.getCurAreaCode().regionCode 
        }
        let url = `api/user_info`
        this.req({
          url: url,
          method: 'get',
          data:{
           // p: this.current,
           // pageSize: this.pageSize,
           // userId: this.queryForm.userId,
           // regionCode: this.queryForm.regionCode,
          }
        }).then(resp => {
          this.buildPageData(resp.data.data)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
      changePage(curPage) {
        this.loading = true
        this.current = curPage
        this.loadPage()
      },

      changeSize(pageSize) {
        this.pageSize = pageSize
        this.loading = true
        this.loadPage()
      },
      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
      resetQueryForm() {
        this.$refs["queryFormRef"].fields.forEach(function (e) {
           e.resetField()
        })
      },
      getDist(){
          //先清空原有数据
          this.queryForm.dist = ''
          this.queryForm.distList = []
          let url = "/province/sys/dcBsgroup/listByParentCode";
          this.req({
          url: url,
          method: 'post',
          data:{
              parentCode: this.queryForm.city
          }
          }).then(resp => {
              this.queryForm.distList = resp.data.list
          }).catch(error => {
              console.log("发生错误："+error)
          })
      },
      changCurRc(){
          let arg = arguments[0]
          let curRc = arg.groupid
          let url = "/province/sys/dcBsgroup/listByParentCode";
          this.req({
              url: url,
              method: 'post',
              data:{
                  parentCode: curRc
              }
          }).then(resp => {
                this.showcity=true;
                this.showcountry=true;
              if(curRc.length==6){   //区县页面
                  this.showcity=false;
                  this.showcountry=false;
              }else if(curRc.length==4){
                  this.showcity=false;
                  this.queryForm.distList = resp.data.list
              }else{
                  this.queryForm.cityList = resp.data.list
              }
          }).catch(error => {
              console.log("发生错误："+error)
          })
          console.log( this.queryForm.distList)
      },
      //清空下拉列表时同时重置数据
      clearCity(){
          this.queryForm.city = ''
          this.queryForm.regionCode = ''
      },
      clearDist(){
          this.queryForm.dist = ''
          this.queryForm.regionCode = ''
      },
      stop(row){
        let url = `/province/sys/user/stop`
        let userState
        //如果是停用改为启用
        if (row.userState == '0') {
          userState = '1'
        } else {
          userState = '0'
        }
        this.req({
          url: url,
          method: 'post',
          data:{
            id: row.id,
            userState : userState,
          }
        }).then(response => {
          if ( userState == '1') {
             this.$Message.success(`${row.userId} 启用成功`);
          } else {
             this.$Message.success(`${row.userId} 停用成功`);
          }
         
          this.loadPage();

        }).catch(error => {
          this.$Message.error('服务器错误:' + error);
        })
      }
    },
    mounted: function () {
        this.resetQueryForm()
          //监听home组件点击区域事件
        Bus.$on("changeCurRc",this.changCurRc)
        this.loadPage()
        let curRc = this.$store.getters.getCurAreaCode().regionCode
        //获取查询条件数据
        let url = "/province/sys/dcBsgroup/listByParentCode";
        this.req({
            url: url,
            method: 'post',
            data:{
                  parentCode: curRc
            }
        }).then(resp => {
                this.showcity=true;
                this.showcountry=true;
                this.queryForm.distList = [] 
                this.queryForm.cityList =[]
              if(curRc.length==6){   //区县页面
                    this.showcity=false;
                    this.showcountry=false;
                }else if(curRc.length==4){
                    this.showcity=false;
                    this.queryForm.distList = resp.data.list
                }else{
                    this.queryForm.cityList = resp.data.list
                }
        }).catch(error => {
            console.log("发生错误："+error)
        })
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        deleteId: '',
        showcity: true,
        showcountry: true,
        columns4: [{
            type: 'index',
            title:'序号',
            width: 70,
            align: 'center',
          },
          {
            title: '用户名',
            align: 'center',
            key: 'userId',
          },
          {
            title: '区域名称',
            align: 'center',
            key: 'groupName'
          },
          {
            title: '状态',
            align: 'center',
            key: 'userState',
            render: (h,params)=>{
                let a =  params.row.userState == 0 ? '停用' : '启用'
                return h('div',a)
            }
          },
          {
            title: '操作',
            slot: 'action',
            width: 300,
            align: 'center'
          }
        ],
        //查询表单的初始值
        queryForm: {
          userId: '',
          city: '',
          dist: '',
          cityList: [],
          distList: [],
          
        },
      }
    },

  }
</script>

<style scoped>
  .ivu-layout-header {
    background: #f5f7f9;
  }

 

  .queryForm {
    padding: 10px;
  }
  .queryBtn {
    padding-bottom: 5px;
    padding-left: 700px;
    border-bottom: rgb(160, 146, 146) solid 1px;
  }
  .optBtn {
    margin: 10px;
  }
  .ivu-form-item {
    margin-bottom: 0px;
  }
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/sys/user/User.vue